export default __webpack_public_path__ + "static/media/qoom.e1e68e32.svg";